jQuery(document).ready(function( $ ) {

  // wrap nav
  $('.pc-nav ul.menu ul.sub-menu').wrap('<div class="pc-dropdown-wrapper"></div>');

  // add sticky on scroll
  window.onscroll = function() {
    pcMainMenu();
  };

  var header = document.getElementById("pc-global-nav");
  var sticky = header.offsetTop;

  function pcMainMenu() {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }

  // check if user is not at the top of page on load
  var scrollAmount = $(window).scrollTop();
  if(scrollAmount > 0) {
    header.classList.add("sticky");
  }

  // hamburger navigation js
  $('.pc-nav--hamburger').on('click',function(e){

    e.preventDefault();
    $('.pc-mobile-nav-wrapper').addClass('pc-open');
    $('body').addClass('pc-frozen');

  });

  // on anything click
  $(document.body).on('click','.pc-mobile-nav-wrapper.pc-open',function(e){
    var t = $(e.target);

    if(t.hasClass('.pc-nav-mobile') || t.closest('.pc-nav-mobile').length) return;

    $('.pc-nav-mobile--close').trigger('click');

  });

  // hamburger navigation js
  $('.pc-nav-mobile--close').on('click',function(e){

    e.preventDefault();
    $('.pc-mobile-nav-wrapper').removeClass('pc-open');
    $('body').removeClass('pc-frozen');

  });

  // keyboard accessibility
  $('.pc-nav nav ul li a').focus( function () {
    $(this).parents('li .pc-dropdown-wrapper').addClass('focused');
  }).blur(function(){
    $(this).parents('li .pc-dropdown-wrapper').removeClass('focused');
  });


  $('.pc-nav-mobile nav ul li.menu-item-has-children > a').on('click',function(e){

    e.preventDefault();
    $(this).parent().toggleClass('open');

  });

  $('.pc-nav-mobile nav ul li.current-page-parent,.pc-nav-mobile nav > div > ul > li.current_page_item.menu-item-has-children,.pc-nav-mobile nav ul li.current_page_ancestor').addClass('open');


});
